import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8c05a426&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8c05a426&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c05a426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c05a426')) {
      api.createRecord('8c05a426', component.options)
    } else {
      api.reload('8c05a426', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8c05a426&scoped=true", function () {
      api.rerender('8c05a426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/csg-return/index.vue"
export default component.exports